import { styled } from '@mui/material/styles';
import { RadioButtonsGroup } from '@components/RadioButtonsGroup';
import PhoneInput from '@components/PhoneInput';

export const StyledRadioButtons = styled(RadioButtonsGroup)({
    marginTop: '16px',
    marginBottom: '24px',
});

export const StyledPhoneInput = styled(PhoneInput)({
    marginBottom: '8px',
});
